import BaseBehavior from '../../../framework/base/base';
import { getLowerCaseUrlParams } from '../../../shared/utilities/getUrlParams';

const classes = {
	column_full: 'v2-dcf-openaccount__content-item--full',
	column_hide: 'v2-dcf-openaccount__content-item--hide',
	dcf_background: 'v2-bg--dcf-background'
};

const overrideCloseButton = () => {
	const closeBtn = document.querySelector('.v2-dcf-openaccount__close');
	const params = getLowerCaseUrlParams();

	if (closeBtn && params.exiturl) {
		closeBtn.addEventListener('click', e => {
			e.preventDefault();
			window.location.href = params.exiturl;
		});
	}
};
class DCFManager extends BaseBehavior {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.columnFull = document.getElementById(this.element.getAttribute('data-target-full'));
		this.columnHide = document.getElementById(this.element.getAttribute('data-target-hide'));
		this.fullWidth = false;

		this.addEventListeners();

		overrideCloseButton();
	}

	addEventListeners() {
		if (!this.columnFull || !this.columnHide) {
			return;
		}

		this.addEventListener(this.element, 'dcfLoaded', e => {
			this.fullWidth = e.detail && e.detail.isFullWidth;
			this.updateWidth();
		});

		this.addEventListener(this.element, 'dcfStepChanged', e => {
			this.fullWidth = e.detail && e.detail.isFullWidth;
			this.updateWidth();
		});

		this.addEventListener(window, 'resize', (/* e */) => {
			this.updateWidth();
		});

		/*
		this.addEventListener(this.element, 'dcfBackClicked', (e) => {
		});
		this.addEventListener(this.element, 'dcfCloseClicked', (e) => {
		});
		*/
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'dcfLoaded');
		this.removeEventListener(this.element, 'dcfStepChanged');
		this.removeEventListener(window, 'resize');
	}

	updateWidth() {
		if (this.fullWidth) {
			this.columnFull.classList.add(classes.column_full);
			this.columnHide.classList.add(classes.column_hide);
			this.columnFull.classList.remove(classes.dcf_background);
		} else {
			this.columnFull.classList.add(classes.dcf_background);
			this.columnFull.classList.remove(classes.column_full);
			this.columnHide.classList.remove(classes.column_hide);
		}
	}

	cleanup() {
		this.removeEventListeners();
	}
}

export default DCFManager;
